export default "__VITE_ASSET__9a96b2f5__"